'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationConfirm = undefined;

var _RegistrationConfirm2 = require('./RegistrationConfirm');

var _RegistrationConfirm3 = _interopRequireDefault(_RegistrationConfirm2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RegistrationConfirm = _RegistrationConfirm3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationConfirm/index.js
// module id = 1748
// module chunks = 0